import { CircularProgress, makeStyles, Theme } from "@material-ui/core";
import classNames from "classnames";
import { memo } from "react";
import { useCircularStyles } from "../../../locations/common";
import styles from "./WidgetCircularValue.module.css";

interface Props {
  value?: number | null;
  valueLabel?: number | string;
  primaryColor?: string;
  onClick?: () => void;
}

const useStyles = makeStyles<Theme, Props>((theme: Theme) => ({
  primaryColor: ({ primaryColor }) => ({
    color: primaryColor || theme.palette.primary.main,
  }),
  secondaryColor: () => ({
    color: theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  }),
}));

export const WidgetCircularValue = memo((props: Props) => {
  const { value, valueLabel, onClick } = props;
  const circularClasses = useCircularStyles();
  const classes = useStyles(props);

  return (
    <div className={styles["widget-circular-wrapper"]}>
      <CircularProgress
        variant="determinate"
        classes={{ colorPrimary: classes.secondaryColor }}
        thickness={5}
        size="5rem"
        value={100}
      />
      <CircularProgress
        variant="determinate"
        className={styles["widget-circular"]}
        classes={{
          circle: circularClasses.circle,
          colorPrimary: classes.primaryColor,
        }}
        thickness={5}
        size="5rem"
        value={value ?? undefined}
      />
      <div
        className={classNames(
          styles["widget-circular-label"],
          styles["category-value"],
          `${classes.labelColor}`,
          `${onClick ? "clickable" : ""}`
        )}
        onClick={onClick}
      >
        {valueLabel ?? value}
      </div>
    </div>
  );
});
